import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SearchIcon from "@material-ui/icons/Search";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import SelectFilter from "react-select";
import DateTimePicker from "react-datetime";

import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";

import moment from "moment";

import MyButton from "../MyButton";

const myLib = require("../../lib/MyLib");
const server = require("../../lib/server");
const sukienLayer = require("../../lib/SuKienDataLayer");

class SuKienTimKiemControl extends React.Component {
  constructor(props) {
    super(props);
    this.saveField = this.saveField.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.state = {
      canSaved: false, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorLog: "", //mo ta loi neu co
      loading_coquan: true, // co dang load ding danh muc nguon tin ko
      source_coquan: [], //danh muc options cho nguon tin
      //searching
      search_loading: false,
      search_result: { danhsach: [], total: 0 }, //ket qua tim kiem
      before:
        props.value === undefined
          ? {
              ThoiGian: new Date(),
            }
          : props.value, //thong tin truoc khi edit
      after:
        props.value === undefined
          ? {
              Page: 1,
              PageSize: 10,
              TenTau: "", //tim kiem theo ten tau
              TuNgay: null,
              DenNgay: null,
              TrangThai: "1",
              MaCQ: "0", //trung tam xu ly
              PhanLoai: "1", //su kien that gia
              Duyet: "-1", //chua duyet
            }
          : props.value, //thong tin dang edit
      validateStatus: { error: false }, //trang thai validate
    };
  }
  componentDidMount() {
    if (this.props.callback) {
      this.props.callback(this.handleSearch);
    }
    this.loadDanhMuc();
  }
  //ghi nhan gia tri nhap
  saveField = (fieldName, value) => {
    //console.log("save field", fieldName, value);
    var s = this.state;
    s.after[fieldName] = value;
    s.dataChanged = true;
    s.canSaved = true;
    this.setState(s);
  };
  //submit thong tin ve DB
  handleSearch = (pageIndex) => {
    if (this.state.canSaved) {
      var search = {};
      Object.assign(search, this.state.after);
      search.Page = pageIndex === undefined ? search.Page : pageIndex;
      this.setState({ saving: true, errorLog: "" });
      //console.log(search);
      server
        .post("sukien/search", search)
        .then((response) => {
          var after = myLib.cloneObject(this.state.after);
          this.setState({
            dataChanged: false,
            canSaved: true,
            saving: false,
            errorLog: "",
            search_loading: false,
            search_result: response,
          });
          //thong bao cho parent biet co data duoc saved
          if (this.props.onSearched) {
            this.props.onSearched(after, response);
          }
        })
        .catch((error) =>
          this.setState({
            saving: false,
            search_loading: false,
            errorLog: error + "",
          })
        );
    }
  };
  loadDanhMuc() {
    //load danh muc doi tac
    server
      .query("coquan/getall")
      .then((response) => {
        var list = [];
        var find = undefined;
        response.map((item, index) => {
          var option = { value: item.MaCQ, label: item.TenCoQuan };
          list.push(option);
          if (item.MaCQ === global.User.MaCQ && find === undefined) {
            find = option;
          }
        });
        list.push({ value: "0", label: "---Tất cả---" });
        //default  theo tai khoan
        var after = myLib.cloneObject(this.state.after);
        find.value = find.value;
        after.MaCQ = find;
        var state = {
          canSaved: true,
          source_coquan: list,
          loading_coquan: false,
          after: after,
        };
        this.setState(state, () => this.handleSearch());
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_coquan: false });
      });
  }
  static getDerivedStateFromProps(props, state) {
    return { ...state };
  }
  render() {
    const { classes, theme } = this.props;
    return (
      <Grid container spacing={2} style={{margin: 4}}>
        <Grid item xs={3}>
          <InputLabel id="labelCoquan">Đơn vị:</InputLabel>
          {this.state.loading_coquan ? (
            <CircularProgress />
          ) : (
            <div style={{ zIndex: 99999 }}>
              <SelectFilter
                id="cboMacq"
                options={this.state.source_coquan}
                placeholder=""
                labelId="labelCoquan"
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                menuPosition={"fixed"}
                value={this.state.after.MaCQ}
                onChange={(item) => this.saveField("MaCQ", item)}
              ></SelectFilter>
            </div>
          )}
        </Grid>
        <Grid item xs={3}>
          <TextField
            id="txtTenTau"
            className={classes.textbox}
            label="Tên sự vụ:"
            value={this.state.after.TenTau}
            inputProps={{
              className: classes.uppercaseText,
              maxLength: 100,
            }}
            onChange={(event) => this.saveField("TenTau", event.target.value)}
          />
        </Grid>
        <Grid item xs={3}>
          <FormControl className={classes.formControl}>
            <InputLabel id="demo-simple-select-label">Trạng thái:</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              className={classes.textbox}
              autoWidth={true}
              labelWidth={100}
              value={this.state.after.TrangThai}
              onChange={(event) =>
                this.saveField("TrangThai", event.target.value)
              }
            >
              <MenuItem value={"1"}>Đang xử lý</MenuItem>
              <MenuItem value={"2"}>Đã kết thúc</MenuItem>
              <MenuItem value={"-1"}>--Tất cả--</MenuItem>
            </Select>
          </FormControl>
        </Grid>
                
        <Grid item xs={3}>
          {this.state.saving ? (
            <CircularProgress />
          ) : this.state.errorLog === "" ? null : (
            this.state.errorLog
          )}
        </Grid>

        <Grid item xs={3}>
          <InputLabel id="labelTungay">Từ ngày:</InputLabel>
          <DateTimePicker
            id="txtTuNgay"
            dateFormat="DD/MM/YYYY"
            timeFormat={false}
            closeOnSelect={true}
            value={this.state.after.TuNgay}
            inputProps={{
                  maxLength: 100,
                  onBlur: (event) => {
                    var text = event.target.value;
                    if(this.state.after.TuNgay === null && text != '') {
                      var date = myLib.tryToDate(text);
                      if(date) {
                        this.saveField('TuNgay', date);
                      }
                    }
                  }
                }}
            onChange={(date) =>
              this.saveField("TuNgay", date && date.toDate ? date.toDate() : null)
            }
          />
        </Grid>
        <Grid item xs={3}>
          <InputLabel id="labelTungay">Đến ngày:</InputLabel>
          <DateTimePicker
            id="txtDenNgay"
            dateFormat="DD/MM/YYYY"
            timeFormat={false}
            closeOnSelect={true}
            value={this.state.after.DenNgay}
            inputProps={{
                  maxLength: 100,
                  onBlur: (event) => {
                    var text = event.target.value;
                    if(this.state.after.DenNgay === null && text != '') {
                      var date = myLib.tryToDate(text);
                      if(date) {
                        this.saveField('DenNgay', date);
                      }
                    }
                  }
                }}
            onChange={(date) =>
              this.saveField("DenNgay", date && date.toDate ? date.toDate() : null)
            }
          />
        </Grid>
        <Grid item xs={3}>
          <FormControl className={classes.formControl}>
            <InputLabel id="demo-simple-select-label">Duyệt:</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              className={classes.textbox}
              autoWidth={true}
              labelWidth={100}
              value={this.state.after.Duyet}
              onChange={(event) =>
                this.saveField("Duyet", event.target.value)
              }
            >
              <MenuItem value={"0"}>Chưa duyệt</MenuItem>
              <MenuItem value={"1"}>Đã duyệt</MenuItem>
              <MenuItem value={"-1"}>--Tất cả--</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2}>
          <MyButton
            onClick={() => this.handleSearch()}
            color="primary"
            size="normal"
            icon={<SearchIcon />}
            text="Tìm kiếm"
          />
        </Grid>
      </Grid>
    );
  }
}
const styles = (theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  thoigian: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  textbox: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  normalPanel: {
    backgroundColor: "lightskyblue",
  },
  expandedPanel: {
    backgroundColor: "skyblue",
  },
  cboMacq: {
    backgroundColor: "gray",
  },
});
export default withStyles(styles, { withTheme: true })(SuKienTimKiemControl);
